import AgeLineChartList from "../../../../../components/Charts/Ageline/AgeLineChartList";



export default function GetTelomereChart() {

const chronologicalAge = 62;

const sampleData = [
  { disease: 'Telomere Length', age: 45 },

];

  return (

      <div style={{ padding: '2rem' }}>
      <AgeLineChartList chronologicalAge={chronologicalAge} data={sampleData} />
    </div>
    
  );
};




